import Company from '@/types/Company'

// Type des documents de la base documentaire (« Guides & Documentations ») : le seul que
// l'editeur du back-office cree, et le seul que les listes de cette base affichent.
export const DOCUMENT_TYPE_DOCUMENTARY_SPACE = 'espaceDocumentaire'

// Source: pharmedigroup-graphql/src/schema/group/Documents/document.graphql (type DocumentItems)
export type DocumentItem = {
  id?: string
  name?: string
  date?: string
  type?: string
  path?: string
  entite?: string
  company?: Company | null
  country?: string
  signed?: boolean
}
